import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaCheck} from "react-icons/fa";
import projectUtils from "../../../../utils/project-utils.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import DevicesActionsCellRenderer from "../../agents/form/components/tabs/devices/devices-actions-cell-renderer.jsx";
import {AgGridReact} from "ag-grid-react";
import DevicesConfigModal from "../../agents/form/components/tabs/devices/devices-config-modal.jsx";

const MyUserDevices = ({devicesFetch, setTarget, refetch, user}) => {
    const [devices, setDevices] = useState([]);
    const [open, setOpen] = useState(false);
    const [deviceSelected, setDeviceSelected] = useState(undefined);

    useEffect(() => {
        setDevices(devicesFetch);
    }, [devicesFetch]);

    const gridRef = useRef(undefined);

    const [columnDefs, ] = useState([
        {
            headerName: "Principal",
            field: "main",
            width: 100,
            sortable: false,
            cellClass: "justify-report-center",
            cellRenderer: ({value}) => {
                if (value) {
                    return (
                        <div className={"flex items-center justify-center h-full"}>
                            <FaCheck color={"#219453"}/>
                        </div>
                    );
                }
            },
        },
        {headerName: "Tipo", field: "type", comparator: aggridUtils.nullLastComparator, width: 150},
        {headerName: "Números", field: "phone", comparator: aggridUtils.nullLastComparator, width: 150, valueFormatter: ({value}) => projectUtils.formatPhone(value)},
        {headerName: "Descrição", field: "description", comparator: aggridUtils.nullLastComparator, flex: 1, minWidth: 300},
        {
            headerName: "Ações",
            field: "",
            width: 90,
            sortable: false,
            cellRenderer: DevicesActionsCellRenderer,
            cellRendererParams: {setOpen, setDeviceSelected, remove: false}
        },
    ]);

    const defaultColDef = useMemo(
        () => ({
            resizable: false,
        }), []
    );

    const onReturn = () => {
        const arraysAreEqual = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false;
            return arr1.every((obj, index) =>
                JSON.stringify(obj) === JSON.stringify(arr2[index])
            );
        };

        if (!arraysAreEqual(devicesFetch, devices)) refetch();

        setTarget("info");
    }

    const height = (devices?.length || 0) * 31 + 60;

    return (
        <>
            <Card>
                <Card.Body>
                    <h3 className="flex gap-2 items-center">
                    <FaArrowLeft className="cursor-pointer font-normal" onClick={() => onReturn()}/>
                        Contatos
                    </h3>

                    <div className={"pt-[15px] px-[15px]"} style={{height: `min(calc(100vh - 115px), ${height}px)`}}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={devices}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <DevicesConfigModal
                devices={devices}
                setDevices={setDevices}
                deviceSelected={deviceSelected}
                open={open}
                setOpen={setOpen}
                user={user}
                userId={user.id}
                myUser={true}
            />
        </>
    );
};

export default MyUserDevices;